Lyte.Component.register("lyte-editor-directory-panel", {
  data: function () {
    return {
      //ignorei18n_start
      activeFilePath: Lyte.attr("string"),
      activeItem: Lyte.attr('string'),
      allowToPopulate: Lyte.attr('boolean', {
        default: true
      }),
      directories: Lyte.attr("object", { default: {} }),
      dynamicInput: Lyte.attr("object"),
      duration: Lyte.attr("string", { default: undefined }),
      errorMessage: Lyte.attr("string", { default: "" }),
      errorColor: Lyte.attr("string", { default: "" }),
      fileUploadAcceptedFiles: Lyte.attr("string", {
        default: ""
      }),
      headerName: Lyte.attr("string"),
      highLight: Lyte.attr("boolean", false),
      isValidName: Lyte.attr("boolean", { default: false }),
      isInputShow: Lyte.attr("boolean", { default: false }),
      isFolderCreator: Lyte.attr("boolean", { default: true }),
      isFileCreator: Lyte.attr("boolean", { default: true }),
      inValid: Lyte.attr("boolean", false),
      item: Lyte.attr("object", { default: {} }),
      msgToUser: Lyte.attr("object", { default: {} }),
      message: Lyte.attr("string", { default: "" }),
      mouseOver: Lyte.attr("boolean", false),
      menuOptions: Lyte.attr("array", { default: [] }),
      menuActiveItem: Lyte.attr("string", { default: "" }),
      name: Lyte.attr("string", { default: "" }),
      uniqueId: Lyte.attr("string"),
      showModal: Lyte.attr("boolean", { default: false }),
      originElem: Lyte.attr('string', {
        default: ""
      }),
      options: Lyte.attr("array", {
        default: [
          { name: Lyte.Editor.I18n.getValueOf("menu_new_file") },
          { name: Lyte.Editor.I18n.getValueOf("menu_open_folder") },
          { name: Lyte.Editor.I18n.getValueOf("menu_upload_file") },
          { name: Lyte.Editor.I18n.getValueOf("menu_rename") },
          { name: Lyte.Editor.I18n.getValueOf("menu_delete") }
        ]
      }),
      popOverValidate: Lyte.attr('string', ''),
      popoverRename: Lyte.attr('boolean', {
        default: false
      }),
      queryProp: Lyte.attr("string", { default: ".leOptionIcon" }),
      restrictCreation: Lyte.attr("array", {
        default: ["component", "dist"]
      }),
      tbActiveItem: Lyte.attr('string', ''),
      warningModal: Lyte.attr("object", { default: {} }),
      wantToShow: Lyte.attr("boolean", { default: true }),
      warningValid: Lyte.attr("boolean", { default: false }),
      tooltipConfig: Lyte.attr("string", {
        default: `{
          "position":"right",
          "appearance":"box",
          "showdelay":200,
          "hidedelay":200,
          "maxdisplaytime":5000,
          "margin":15
        }`}),
      menuToolTipConfig: Lyte.attr("string", {
        default: `{
          "position":"bottomright",
          "appearance":"box",
          "showdelay":200,
          "hidedelay":200,
          "maxdisplaytime":5000,
          "margin":5
        }`}),
      leftPanelConfig: Lyte.attr('object', {
        default: {},
        watch: true
      }),
      openState: Lyte.attr('boolean', {
        default: false
      }),
      headerIconsData: Lyte.attr('array', {
        default: [
          {
            iconType: 'createFile',
            toolTip: 'New File',
          },
          {
            iconType: 'createFolder',
            toolTip: 'New Folder',
          },
          {
            iconType: 'collapseFolder',
            toolTip: 'Collapse Folders in Explorer',
          }
        ]
      })
      //ignorei18n_end
    };
  },
  init: function () {
    this.setData('activeItem', this.getData('item').id);
    this.subscribeTo(
      "SET_MENUDATA",
      function (value) {
        this.setData("menuActiveItem", value);
      }.bind(this)
    );
    this.subscribeTo("REFRESH_FILE_LIST", function (value) {
      this.setData('item', value);
    });
    this.subscribeTo("RENAME_DIR", function (path, name, errorCallback) {
      this.renameDirOnDataAndDom(path, name, errorCallback);
    });
    this.subscribeTo("CREATE_FILE", function (name, fileContent, path, errorCallback, restrictActive) {
      this.createDirectoryByPathName(name, "file", fileContent, path, errorCallback, restrictActive);
    });
    this.setData("uniqueId", this.getData("item").id);

  },
  didConnect: function () { this.changingItemObs() },
  deleteDirItem(itemNode, menuItemId) {
    const isFile = Boolean(itemNode.getAttribute("is-file"));
    const currIndex = Number.parseInt(itemNode.getAttribute("index"));
    const editorInstance = _led.getInstance(this.data.editorId);
    let parentComp;
    itemNode = itemNode.closest("lyte-editor-directory-panel-item");
    if (isFile) {
      this.getEditorInstance(this.getData("editorId")).pubsub.fire(
        "DISPOSE_TABITEM",
        menuItemId
      );
      editorInstance.triggerMethod("onFileDelete", editorInstance.directory.getFileModelObj(menuItemId));
      itemNode.component.deleteDirData(menuItemId);
    } else {
      parentComp = itemNode.component.getParentComp();
      this.setData("allowToPopulate", false);
      editorInstance.triggerMethod("onFolderDelete", editorInstance.directory.getFolderModelObj(menuItemId));
      itemNode.component.deleteDirData(menuItemId);
    }
    this.setData("allowToPopulate", true);
    const itemActive = this.getData("tbActiveItem");
    if (!itemActive) {
      const itemComp = itemNode.component;
      if (this.getData("activeItem") == menuItemId) {
        if (isFile) {
          itemComp.makeNextActive(isFile, currIndex);
        } else {
          if (parentComp) {
            parentComp.makeNextActive(isFile, currIndex);
          } else {
            this.setData("activeItem", this.getItemId());
          }
        }
      }
    } else {
      this.populateAndActivateItem(itemActive);
    }
  },
  setCustomProp(value) {
    //checking for custom obj and if it is , set the custom prop
    this.setData('customOption', value);
  },
  resetCustomOptionData() {
    this.setData('customOption', undefined);
  },
  resetContextMenuData() {
    this.setData('contextDirType', undefined);
  },
  itemChangeInitialize: function () { this.changingItemObs() }.observes("item"),
  changingItemObs: function (obs) {
    const leftPanelConfig = this.data.leftPanelConfig;
    this.getEditorInstance(this.getData("editorId")).pubsub.fire(
      "SETDRAGANDDROP"
    );
    this.setData("activeItem", this.getData("item").id);

    this.setFileExplorerRestrictMenu(this.getData("ltPropRestrict"), function (dataObj) {
      const type = dataObj.type;
      const node = dataObj.node;
      const path = dataObj.path;
      if (type == 'file') {
        this.destroyDraggableByNode(node)
        node.setAttribute("restrict", true);
      }
      else {
        const comp = node.closest('lyte-editor-directory-panel-item').component;
        if(leftPanelConfig.onlyParent && leftPanelConfig.onlyParent.includes(path)) {
          comp.setData("restrictParent", true);
        }
        else {
          comp.setData("restrict", true);
        }
      }
    }.bind(this));
  },
  renameDir(itemNode, menuItemId) {
    const comp = itemNode.closest(
      "lyte-editor-directory-panel-item"
    ).component;
    const item = comp.getItemData(menuItemId);
    const itemName = item.name;
    Lyte.Component.set(item, "isRename", true);
    comp.setData("isRename", true);
    comp.setData("renameValue", itemName);
    this.setData({
      originElem: `[unique-id=${item.id}] lyte-input`
    });
    const inputNode = comp.nodePicker(itemNode, ":scope lyte-input");
    inputNode.focus();
    const lastDotIndex =  itemName.lastIndexOf('.'); // Select only fileName not with extension
    if(item.type == 'file' && lastDotIndex > -1){
      inputNode.querySelector('input').setSelectionRange(0, lastDotIndex);
    }
    else{
      inputNode.select();
    }
    
    // inputNode.select();
  },
  errorMessageSetter: function (dataObj) {
    const code = dataObj.code;
    const value = dataObj.value;

    const errorObj = this.executeMethod("getErrorLog", code, value);
    this.setData("errorMessage", errorObj.error);
    this.setData('popOverValidate', errorObj.state);
    this.setData("errorColor", this.getErrorColor(code));
  },
  showModalObserver: function () {
    Lyte.PageBuilder.State.WHITEBOARD_IS_VISIBLE.set(this.data.showModal);
  }.observes("showModal"),
  populateDirectoryobs: function (observerObj) {
    const newActiveItem = observerObj.newValue;
    if (newActiveItem && this.getData('allowToPopulate')) {
      this.populateAndActivateItem(newActiveItem);
    }
  }.observes('tbActiveItem'),
  menuOptionActions(option) {
    switch (option) {
      case "New File": {
        return function () {
          const menuActiveId = this.getData("menuActiveItem");
          const compNode = this.panelCompFinder(this.$node, menuActiveId);
          compNode.component.activateItem(
            compNode.querySelector("div"),
            "leHighlight",
            menuActiveId
          );
          this.genericFileCreator("file");
        };
      }
      case "New Folder": {
        return function () {
          const menuActiveId = this.getData("menuActiveItem");
          const compNode = this.panelCompFinder(this.$node, menuActiveId);
          compNode.component.activateItem(
            compNode.querySelector("div"),
            "leHighlight",
            menuActiveId
          );
          this.genericFileCreator("folder");
        };
      }
      case "Open Folder": {
        return function () {
          const menuId = this.getData("menuActiveItem");
          const menuNode = this.panelCompFinder(this.$node, menuId);
          menuNode.component.createFileOpenModal(true);
        };
      }
      case "Upload File": {
        return function () {
          this.uploadFile();
        }
      }
      case "Rename": {
        return function () {
          const menuItemId = this.getData("menuActiveItem");
          const comp = this.panelCompFinder(this.$node, menuItemId);
          this.renameDir(comp, menuItemId);
        };
      }
      case "Delete": {
        return function () {
          const menuItemId = this.getData("menuActiveItem");
          let itemNode = this.panelCompFinder(this.$node, menuItemId);
          this.deleteDirItem(itemNode, menuItemId);
        };
      }
    }
    return false;
  },
  makeErrorBoxDirty: function () {
    this.setData('popOverValidate', 'error');
  },
  populateAndActivateItem(activeId, dataObj) {
    const parentScroller = this.nodePicker(this.$node, ".allDirectory");
    const populateNodes = this.populateDirectory(activeId, dataObj);
    const directoryItem = populateNodes.comp;
    const directoryNode = populateNodes.node;
    directoryItem.activateItemById(activeId);
    this.makeScroll(directoryNode, parentScroller, "vertical");
  },
  checkRestrictedFileType: function (item) {
    const editorInstance = _led.getInstance(this.data.editorId);
    let fileEligible = false;
    let folderEligible = false;
    if (!this.isRestricted(item.name)) {
      const mainItem = editorInstance.folder.getDirectoryData(item.id);
      if (mainItem.create.file) {
        fileEligible = true;
      }
      if (mainItem.create.folder) {
        folderEligible = true;
      }
    }
    this.setFileCreateEligible(fileEligible);
    this.setFolderCreateEligible(folderEligible);
  },
  resetLeftPanel: function () {
    this.getEditorInstance(this.getData("editorId")).pubsub.fire("RESET_LEFTPANEL"); //No I18n
    this.removeActive();
    this.resetDefaults();
  },
  isRestricted: function (folderName) {
    folderName = folderName.toLowerCase();
    const restrictArray = this.getData("restrictCreation");
    return restrictArray.includes(folderName);
  },
  setFileCreateEligible: function (booleanValue) {
    this.setData("isFileCreator", booleanValue);
  },
  setFolderCreateEligible: function (booleanValue) {
    this.setData("isFolderCreator", booleanValue);
  },
  setCssProps: function (styleObj, cssProps) {
    for (const prop in cssProps) {
      const val = cssProps[prop];
      styleObj[prop] = val;
    }
  },
  resetDefaults: function () {
    this.setData({
      isFileCreator: true,
      isFolderCreator: true
    });
    this.executeMethod("settingNodeAPI", this.getItemId());
  },
  getChildren: function () {
    return this.getData("directories");
  },
  setActiveItemData: function (itemId) {
    this.executeMethod("settingNodeAPI", itemId);
  },
  removeActive: function () {
    const editorInstance = _led.getInstance(this.getData('editorId'));
    const activeItem = this.$node.querySelector(".leActive");
    if (activeItem) {
      activeItem.classList.remove("leActive");
    }
    editorInstance.triggerMethod("onDirDeactive");
  },
  genericFileCreator: function (fileType) {
    let allowable = false;
    switch (fileType) {
      case "file": {
        allowable = this.getData("isFileCreator");
        break;
      }
      case "folder": {
        allowable = this.getData("isFolderCreator");
        break;
      }
    }
    if (allowable) {
      const targetId = this.getData('activeItem') || this.getData('item').id;
      let targetNode = this.panelCompFinder(this.$node, targetId);
      targetNode = targetNode.closest('lyte-editor-directory-panel-item');
      const targetComponent = targetNode.component;
      const originId = targetComponent.getItemId();
      const inputFieldSelector = targetComponent.getInputFieldSelector();
      targetComponent.createFileOpenModal(true);
      targetComponent.setData("isInputShow", true);
      targetComponent.setData("inFileOrFolderCreation", fileType);
      targetComponent.setData("isCreateFile", fileType === "file");
      targetComponent.lyteInputObserver(
        inputFieldSelector
      );

      this.setData('originElem', `[unique-id=${originId}] ${inputFieldSelector}`);
    }
  },
  getOptionData(id) {
    let options = this.getData('menuOptions');

    //get id without '/' starting
    id = id.slice(1);
    const idArr = id.split('/'); //getting key array
    let resultObj;
    for (let eachId of idArr) {
      resultObj = options.find((eachOptionObj) => {
        const name = eachOptionObj.name;
        return name == eachId;
      })
      if (resultObj) {
        options = resultObj.child;
      }
      else {
        console.error('Menu Item is not found');
      }
    }
    return resultObj;
  },
  getItemByPathName(path) {
    let compId;
    const editorInst = _led.getInstance(this.getData('editorId'));
    const result = {};
    if (path) {
      const dirObj = editorInst.folder.getDirByPath(path);
      if (dirObj) {
        compId = dirObj.uniqueId;
        result.dirObj = editorInst.directory.getSingleDirectory(
          dirObj);
        result.node = this.panelCompFinder(this.$node, compId);
        result.comp = result.node.closest(
          "lyte-editor-directory-panel-item"
        );
        const type = dirObj.type;
        result.restrict = type == 'file' ? Boolean(result.node.getAttribute("restrict")) : result.comp.component.restrictFlagChecker();
      }
      else {
        throw this.generateError(400, [path])
      }
    }
    else {
      compId = this.getData('menuActiveItem');
      result.node = this.panelCompFinder(this.$node, compId);
      result.comp = result.node.closest(
        "lyte-editor-directory-panel-item"
      );
      result.dirObj = result.comp.component.getItemData(compId);
      const type = result.dirObj.type;
      result.restrict = type == 'file' ? Boolean(result.node.getAttribute("restrict")) : result.comp.component.restrictFlagChecker();
    }

    return result;
  },
  uploadFileToDirPanel(file, errorCallback) {
    const name = file.name;
    const self = this;
    const menuNode = this.panelCompFinder(
      this.$node,
      this.data.currMenuActiveItem)
    const reader = new FileReader();
    reader.readAsText(file);
    reader.addEventListener("load", function () {
      const result = this.result;
      const createdItem = menuNode.component.createPanelDirectory(name, "file", result, true, errorCallback);
      // const fileOpen = menuNode.component.getData("isFilesOpen");
      // if (!fileOpen) {
      //   menuNode.component.createFileOpenModal(true);
      //   menuNode.component.throwEvent("openDirectoryUi");
      // }
      self.populateAndActivateItem(createdItem.id);


    });
  },
  modifyDirMenuOptions(defaultOptions, optionalCallback, jsonData) {
    const editorInstance = this.getEditorInstance(this.getData("editorId"));
    if (editorInstance.getMethods('setDirMenuOption')) {
      const customOptions = editorInstance.triggerMethod('setDirMenuOption', defaultOptions.slice(), jsonData);
      if (!customOptions) {
        this.setCustomProp(false);
        this.executeMethod("setOptionMenuData", defaultOptions);
      }
      else {
        this.setCustomProp(true);
        this.setUniqueIdToOptions(customOptions);
        optionalCallback(customOptions);
        this.executeMethod("setOptionMenuData", customOptions);
      }
    }
    else {
      this.setUniqueIdToOptions(defaultOptions);
      this.executeMethod("setOptionMenuData", defaultOptions.slice());
    }

  },
  getCustomMenuByName(nameValue) {
    const customOptions = this.data.menuOptions;
    function getOption(menuArr) {
      for (let eachMenuOpt of menuArr) {
        if (eachMenuOpt.name == nameValue) {
          return eachMenuOpt;
        }
        else {
          const child = eachMenuOpt.child;
          if (child) {
            return getOption(child);
          }
        }
      }
      return false;
    }
    return getOption(customOptions);
  },
  uploadFile(path, errorCallback) {
    try {
      this.setData('onMenuError', errorCallback);
      if (path) {
        const itemDetails = this.getItemByPathName(path);
        const restrict = itemDetails.restrict;
        const type = itemDetails.dirObj.type;
        const name = itemDetails.dirObj.name;
        // if(restrict==true)
        // {
        //   throw this.generateError(501,['upload',type,name]);
        // }
        if (type == 'folder') {
          const comp = itemDetails.comp;
          const id = comp.component.data.uniqueId;
          const currId = this.getData("menuActiveItem");
          this.setData("currMenuActiveItem", id);
          setTimeout(function () { document.querySelector("lyte-fileupload.dir-fileUpload").component._file.click(); }, 0)
        }
        else {
          throw this.generateError(500, ['upload', type, 'folder']);
        }
      }
      else {

        //checking type
        const activeId = this.getData("menuActiveItem");
        const dirObj = this.getEditorInstance(this.getData("editorId")).folder.getDirectoryData(activeId);
        const type = dirObj.type;
        if (type == 'folder') {
          this.setData("currMenuActiveItem", activeId);
          setTimeout(function () { document.querySelector("lyte-fileupload.dir-fileUpload").component._file.click(); }, 0)
        }
        else {
          throw this.generateError(500, ['upload', type, 'folder']);
        }
      }
    }
    catch (error) {
      this.handleMenuOptionError(error, errorCallback, function () {
        this.setData('currMenuActiveItem', undefined);
        this.setData('onMenuError', undefined);
      })
    }
  },
  setUniqueIdToOptions(options) {
    //loop array
    function setId(options, basePath) {
      options.forEach((eachOption) => {
        const idValue = basePath + '/' + eachOption.name;
        Object.defineProperty(eachOption, _led.DIRMENU_ID, {
          value: idValue,
          enumerable: false
        })
        if (eachOption.child) {
          setId(eachOption.child, idValue);
        }
      })
    }
    setId(options, '');
  },
  removeChildMenuAndResetData(lyteMenu) {
    const self = this;
    function removeChildMenu(childArr) {
      childArr.forEach((eachMenu) => {
        self.$node.removeChild(eachMenu);
      })

    }
    //remove childArr
    const childArr = lyteMenu.component.data.childArr;
    childArr && removeChildMenu(childArr);
    //remove icon list
    const iconList = lyteMenu.component.data.iconList;
    iconList && iconList.forEach((eachIcon) => {
      eachIcon.remove();
    })
    //remove datas
    lyteMenu.setData('menuData', undefined);
    lyteMenu.setData('childArr', undefined);
    lyteMenu.setData("iconList", undefined);
  },
  handleMenuOptionError(error, errorCallback, nonErrorHandle) {
    if (error.errorCode && _led.LEFT_DIRECTORY_ERROR[error.errorCode]) {
      if (errorCallback) {
        errorCallback(error);
      }
      else {
        if (nonErrorHandle) {
          nonErrorHandle(error);
        }
      }
    }
    else {
      console.error(error);
    }
  },
  setFileExplorerRestrictMenu(pathArr, postCallback) {
    if (!pathArr) {
      return false;
    }
    for (let eachPath of pathArr) {
      try {
        const dirObj = this.getEditorInstance(this.data.editorId).folder.getDirByPath(eachPath);
        const uniqueId = dirObj.uniqueId;
        const type = dirObj.type;
        const node = this.panelCompFinder(this.$node, uniqueId);
        postCallback({
          node: node,
          type: type,
          uniqueId: uniqueId,
          dirObj: dirObj,
          path: eachPath
        })
      }
      catch (error) {
        const errorCode = error.errorCode;
        if (!errorCode || !_led.LEFT_DIRECTORY_ERROR[errorCode]) {
          console.error(error);
        }
      }
    }
  },
  createDirectoryByPathName : function(nameValue, fileType, fileContent, path, errorCallback, restrictActive) {
    try {
      const itemDetails = this.getItemByPathName(path);
      const comp = itemDetails.comp;
      const type = itemDetails.dirObj.type;
      const restrict = itemDetails.restrict;
      const name = itemDetails.dirObj.name;
      // if(restrict==true)

      // {
      //   throw this.generateError(501,['create',type,name]);
      // }
      if (type == 'folder') {
        comp.component.createPanelDirectory(nameValue, fileType, fileContent, restrictActive || false, errorCallback);
      }
      else {
        throw this.generateError(500, ['create', type, 'folder']);
      }

    }
    catch (error) {
      this.handleMenuOptionError(error, errorCallback)
    }
  },
  renameDirOnDataAndDom : function (path, newName, errorCallback) {
    //base case
    try {
      if (path == '/') {
        throw (this.generateError(300, ['rename', 'root']))
      }
      else {
        const itemDetails = this.getItemByPathName(path);
        const id = itemDetails.dirObj.id;
        const comp = itemDetails.comp;
        this.renamePanelDirectory(newName, comp, id, errorCallback);
      }
    }
    catch (error) {
      this.handleMenuOptionError(error, errorCallback);
    }
  },
  actions: {
    restrictedFileType: function (item) {
      this.checkRestrictedFileType(item);
      return;
    },
    headerIconClickHandler: function (iconType) {
      switch (iconType) {
        case 'createFile': {
          this.genericFileCreator('file'); //No I18n
          break;
        }
        case 'createFolder': {
          this.genericFileCreator('folder'); //No I18n
          break;
        }
        case 'collapseFolder': {
          this.resetLeftPanel();
          break;
        }
      }
    },
    setErrorMessage: function (dataObj) {
      this.errorMessageSetter(dataObj);
    },
    resetErrorPopOver: function () {
      this.setData('popoverRename', false);
      this.setData("popOverValidate", '');
      this.setData("errorMessage", "");
      this.setData("errorColor", "");
    },
    activateMe: function () {
      this.removeActive();
      this.resetDefaults();
      return false;
    },
    openDirectoryUi: function () {
      return false;
    },
    popOverData: function (dataObj) {
      this.setData(dataObj);
    },
    genericFileCreator: function (fileType) {
      this.genericFileCreator(fileType);
    },
    activePathSet: function (path) {
      this.setData("activeFilePath", path);
    },
    resetClick: function () {
      this.resetLeftPanel();
    },
    populateAndActivateItem: function (id) {
      this.populateAndActivateItem(id);
    }
  },
  methods: {
    beforeFileAdd: function (file, element) {
      this.uploadFileToDirPanel(file, this.getData('onMenuError'));
    },
    optionMenuBeforeOpen: function (lyteMenu, event, originElem) {
      //User callback attached
      let options = this.getData("options");
      //check for setDirMenuOption callback
      const eventTriggered = lyteMenu.getData("ltPropEvent");
      const jsonData = {};
      if (eventTriggered == 'contextmenu') {
        const itemId = originElem.getAttribute('unique-id');
        const restrict = originElem.getAttribute('restrict');
        if (this.getItemId() === itemId) {
          return false;
        }
        const comp = originElem
          .closest("lyte-editor-directory-panel-item")
          .component
        const item = comp.getItemData(itemId)
        Object.assign(jsonData, item);
        const pathArr = this.getEditorInstance(this.getData('editorId')).folder.generatePath(itemId);
        const path = pathArr.join('/');
        jsonData.path = path;
        delete jsonData.id;
        const itemType = item.type;

        const itemRestrict = comp.restrictFlagChecker();
        const restrictMenu = comp.getData("restrictMenuIcon");
        if (itemRestrict == true || restrict == "true" || restrictMenu == true) {
          return false;
        }
        this.setData("menuActiveItem", itemId);
        options = itemType === "file" ? options.slice(-2) : options;
      }
      else {
        const id = this.getData('menuActiveItem');
        const comp = this.panelCompFinder(this.$node, id).component;
        Object.assign(jsonData, comp.getItemData(id));
        const pathArr = this.getEditorInstance(this.getData('editorId')).folder.generatePath(id);
        const path = pathArr.join('/');
        jsonData.path = path;
        delete jsonData.id;
      }
      // const jsonData = this.executeMethod('getJsonDataByPath',pathArr);
      this.modifyDirMenuOptions(options, function (data) {
        lyteMenu.setData('menuData', data);
      }, jsonData);
      //Add custom property true if it is custom 
      //make map obj;
      return true;
    },
    getPopOverData: function (dataArray) {
      const self = this;
      return dataArray.reduce(function (acc, eachDataKey) {
        acc[eachDataKey] = self.getData(eachDataKey);
        return acc;
      }, {});
    },
    popOverActions: function (methodName, dataObj) {
      return this[methodName](dataObj);
    },
    setOptionMenuData: function (optionsArray) {
      const menuOption = this.getData("menuOptions");
      Lyte.arrayUtils(
        menuOption,
        "splice",
        0,
        menuOption.length,
        optionsArray
      );
    },
    settingNodeAPI: function (id) {
      this.setData("activeItem", id);
    },
    getErrorLog: function (code, value) {
      let error = "";
      let state = '';
      switch (code) {
        case 204: {
          state = 'error';
          error = "A file or folder name must be provided";
          break;
        }
        case 409: {
          state = 'error';
          error = `A file or folder '${value || ""
            }' already exists at this location, Please choose a different name.`;
          break;
        }
        case 404: {
          state = 'warn';
          error =
            "Leading or trialing whitespaces detected in file or folder Name";
          break;
        }
      }

      return { error, state };
    },
    popoverBeforeShow: function (isRename, popoverComp) {
      let wrapperNode;

      if (isRename) {
        const activeId = this.getData("menuActiveItem");
        let itemNode = this.panelCompFinder(this.$node, activeId);
        const isFile = Boolean(itemNode.getAttribute('is-file'));
        if (!isFile) {
          itemNode = itemNode.closest('lyte-editor-directory-panel-item');
        }
        wrapperNode = itemNode.querySelector(
          "lyte-input.leInput"
        );
      } else {
        const activeId = this.getData("activeItem");
        wrapperNode = this.panelCompFinder(this.$node, activeId).closest("lyte-editor-directory-panel-item").querySelector(
          "lyte-input.leInput"
        );
      }
      //CODE_CHECK : why you have done three write operation here.
      const wrapperNodeBcr = getComputedStyle(wrapperNode);
      popoverComp.setData(
        "ltPropWidth",
        `${wrapperNode.clientWidth -
        (Number.parseInt(wrapperNodeBcr.paddingLeft) +
          Number.parseInt(wrapperNodeBcr.paddingRight))
        }px`
      );
      return this.getData("inValid");
    },
    optionMenuClicked: function (
      value,
      event,
      element,
      menuOriginElem,
      clickedItemAndSubmenu_detail
    ) {
      //check for custom options

      const isCustom = this.data.customOption;
      const self = this;
      function createFile(nameValue, fileContent, path, errorCallback, restrictActive) {
        return self.createDirectoryByPathName(nameValue, "file", fileContent, path, errorCallback, restrictActive);
      }
      function createFolder(nameValue, path, errorCallback) {
        return self.createDirectoryByPathName(nameValue, "folder", '', path, errorCallback);
      }
      function deleteDir(path, errorCallback) {
        try {
          if (path == '/') {
            throw self.generateError(300, ['delete', 'root']);
          }
          else {
            const itemDetails = self.getItemByPathName(path);
            const id = itemDetails.dirObj.id;
            const type = itemDetails.dirObj.type;
            const comp = itemDetails.comp;
            const restrict = itemDetails.restrict;
            const name = itemDetails.dirObj.name;
            // if(restrict==true)
            // {
            //   throw self.generateError(501,['delete',type,name]);
            // }
            self.deleteDirItem(type == "folder" ? comp : itemDetails.node, id);
          }
        }
        catch (error) {
          self.handleMenuOptionError(error, errorCallback)
        }
      }

      if (isCustom) {
        //get clicked Obj
        //first check subMenuItem
        const option = this.getOptionData(clickedItemAndSubmenu_detail.element.getAttribute(_led.DIRMENUATTR_ID));

        if (!option.child) {
          //sending API data
          const editorInst = this.getEditorInstance(this.getData('editorId'));
          const activeItem = this.getData("menuActiveItem");
          const itemObj = editorInst.folder.getDirectoryData(activeItem);
          const type = itemObj.type;
          const inputObj = type == "folder" ? {
            newFile: this.menuOptionActions("New File").bind(this),
            newFolder: this.menuOptionActions("New Folder").bind(this),
            openFolder: this.menuOptionActions("Open Folder").bind(this),
            rename: this.menuOptionActions("Rename").bind(this),
            delete: this.menuOptionActions("Delete").bind(this)
          } : {
            rename: this.menuOptionActions("Rename").bind(this),
            delete: this.menuOptionActions("Delete").bind(this)
          }
          const API = {
            panelUI: inputObj,
            createFile: createFile,
            createFolder: createFolder,
            deleteDir: deleteDir,
            renameDir: this.renameDirOnDataAndDom,
            uploadFile: this.uploadFile.bind(this)
          }
          editorInst.triggerMethod('onDirMenuClick', option, API, itemObj.path);
        }
      }
      else {
        const optionCallback = this.menuOptionActions(value);
        if (optionCallback) {
          this.setData("menuOption", value);
          optionCallback.call(this);
        }
      }
      this.resetContextMenuData();
    },
    handleMenuOptionError: function (error, errorCallback, nonErrorHandle) {
      if (error.errorCode && _led.LEFT_DIRECTORY_ERROR[error.errorCode]) {
        if (errorCallback) {
          errorCallback(error);
        }
        else {
          if (nonErrorHandle) {
            nonErrorHandle(error);
          }

        }
      }
      else {

        console.error(error);
      }
    },
    beforeDestroy: function () {
      const allowables = ["rename"];
      const clickedmenuOption = this.getData("menuOption");
      const isCustom = this.data.customOption
      const isRename = this.getData("renameFolder");
      return (
        isRename != true || clickedmenuOption &&
        !allowables.includes(clickedmenuOption.toLowerCase())
      );
    },
    contextMenudataSetter: function (menu, event, originElem) {
      const itemId = originElem.getAttribute("unique-id");
      if (this.getItemId() === itemId) {
        return false;
      }
      const item = originElem
        .closest("lyte-editor-directory-panel-item")
        .component.getItemData(itemId);
      const itemType = item.type;
      this.setData("menuActiveItem", itemId);
      this.setData('contextDirType', itemType);
      const options = itemType === "file" ? this.getData("options").slice(-2) : this.getData("options");
      return options;
      // const customOptions = this.getEditorInstance(this.getData("editorId")).triggerMethod('setDirMenuOption',options.slice()) || options;
      // this.setCustomProp(options,customOptions);
      // this.executeMethod("setOptionMenuData", customOptions);
    },
    createFileOpenModal: function () {
      return true;
    },
    optionMenuAfterOpen(lyteMenu) {
      const customOptions = lyteMenu.component.data.menuData || lyteMenu.component.data.ltPropContent;
      if (this.data.customOption) {
        //setting uniqueId;
        const menuItems = lyteMenu.component.menuBody.querySelectorAll('lyte-menu-item');
        for (let eachMenuItemIndx = 0; eachMenuItemIndx < menuItems.length; eachMenuItemIndx++) {
          const eachMenuItem = menuItems[eachMenuItemIndx];
          const optionUniqueId = customOptions[eachMenuItemIndx][_led.DIRMENU_ID];
          eachMenuItem.setAttribute(_led.DIRMENUATTR_ID, optionUniqueId);
        }
        for (let option of customOptions) {
          if (option.child) {
            //create dynamic menu
            const menu = document.createElement('lyte-menu');
            const self = this;
            //set datas
            menu.setData({
              'ltPropContent': option.child,
              'ltPropUserValue': 'name',
              'ltPropCallout': true,
              'ltPropPosition': 'right',
              'ltPropEvent': 'mouseenter',
              'lt-prop-query': `lyte-menu-item[${_led.DIRMENUATTR_ID}='${option[_led.DIRMENU_ID]}']`,
              'lt-prop-wrapper-class': 'le-dir-menubox'
            })

            menu.setMethods({
              'onOpen': self.getMethods('optionMenuAfterOpen').bind(self),
              'onClose': self.getMethods('optionMenuOnClose').bind(self),
              'onMenuClick': self.getMethods('optionMenuClicked').bind(this)
            });

            //append menu
            this.$node.appendChild(menu);

            //adding icon to menuItem
            const parentMenuItem = lyteMenu.component.menuBody.querySelector(`lyte-menu-item[${_led.DIRMENUATTR_ID}='${option[_led.DIRMENU_ID]}']`);

            //icon
            const rightIcon = document.createElement('span');
            rightIcon.classList.add('leIcon', 'rightIcon', 'le-menu--right-icon');
            parentMenuItem.appendChild(rightIcon);

            //store lyte Menu to parentMenu
            const childArr = lyteMenu.component.data.childArr;
            if (childArr) {
              childArr.push(menu);
              //push icon selector
              const icons = lyteMenu.component.data.iconList;
              icons.push(rightIcon);
            }
            else {
              lyteMenu.setData('childArr', [menu]);
              lyteMenu.setData('iconList', [rightIcon]);
            }
          }
        }

      }
    },
    optionMenuOnClose(lyteMenu) {
      // this.removeChildMenuAndResetData(lyteMenu)
      setTimeout(function () { this.removeChildMenuAndResetData(lyteMenu) }.bind(this), 0);
      return true;
    },
    parentMenuOnClose(lyteMenu) {
      setTimeout(function () {
        this.removeChildMenuAndResetData(lyteMenu);
        this.resetCustomOptionData();
      }.bind(this), 0);
      return true;
    }
  }
},
  {
    mixins: [
      "ledManageSubEvents", //No I18n
      "ledMakeActive", //No I18n
      "ledLeftPanelUtils" //No I18n
    ]
  }
); 
